import axios from "axios";
import { reactive } from "vue"
import { notification } from "ant-design-vue";
var ltRest = function (config) {
  if (typeof config === "string")
    this._config = {
      service: config,
    };
  else {
    this._config = {
      service: null, //服务名称
      dataFilter: null,
    };

    if (config) {
      if (config.service) this._config.service = config.service;
      if (config.dataFilter) this._config.dataFilter = config.dataFilter;
    }
  }

  this._init();
};

ltRest.prototype._init = function () {
  var _this = this;

  var instance; //最终返回的实例
  //初始化axios实例

  instance = axios.create({
    baseURL: this._getBaseUrl(), //"http://192.168.1.217:8300",//this._getBaseUrl(),
    timeout: 20000,
    headers: {
      "Content-Type": "application/json",
    },
  });


  // 添加请求拦截器
  instance.interceptors.request.use(
    function (config) {
      // 在发送请求之前做些什么

      if (config.params == undefined) config.params = {};
      //在url那里加入access_token参数，access_token参数保存在全局配置LtConfig.accessToken里
      let localLtConfig = {}
      if (typeof LtConfig != "undefined") {
        localLtConfig = reactive(LtConfig)
      } else {
        let temp = localStorage.getItem("LtConfig")
        if (temp) {
          localLtConfig = JSON.parse(temp)
        }
      }
      //加个时间戳清缓存
      config.params.timestamp = new Date().getTime();
      if (localLtConfig.accessToken != null && localLtConfig.accessToken != "") {
        config.headers = {
          token: localLtConfig.accessToken,
        };
      }
      if(localLtConfig.ifUseLicense){
        if(localLtConfig.AcctId!==null && localLtConfig.AcctId!==""&& localLtConfig.AcctId!==undefined){
          config.headers.AcctId=localLtConfig.AcctId;
        }
      }
      if (config.method === "get") {
        //  给data赋值以绕过if判断
        config.data = true;
      }

      config.headers["Content-Type"] = "application/json";
      return config;
    },
    function (error) {
      // 对请求错误做些什么
      console.log("请求抛出的错误是:" + error);
      return Promise.reject(error);
    }
  );

  // 添加响应拦截器
  instance.interceptors.response.use(
    function (response) {
      // 对响应数据做点什么
      // console.log(response.data);
      //  console.log(response.status);
      //console.log(response.statusText);
      // console.log(response.headers);
      //console.log(response.config);
      if (response.Message != undefined && response.Message != null) {
        // message.error(response.Message, 10);
        showErrorInfo(response.Message, 10)
        console.error("拦截返回" + response.Message)
      }
      console.log(response);

      if (
        _this._config.dataFilter &&
        typeof _this._config.dataFilter == "function"
      ) {
        response.data = _this._config.dataFilter(response.data);
      }
      //LtConfig.ifLogin = false;

      return response.data;
    },
    function (error) {
      // 对响应错误做点什么

      if (error.response) {
        // 请求已发出，但服务器响应的状态码不在 2xx 范围内
        // console.log(error.response.data);
        //console.log(error.response.status);
        // console.log(error.response.headers);
        console.error(error.response.data);
        console.error(error.response);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Error", error.message);
        console.error(error.config);
      }
      if (error.response.data.Message == "非法授权") {
        //如果非法授权，则不弹出提示信息，退出到登录界面

        // message.error("该用户已经在其他地方登录，请重新登录！", 15);
        showErrorInfo("该用户已经在其他地方登录，请重新登录！", 15)
        // LtConfig.ifLogin = true;
      } else {
        showError(error);
      }
      console.log("返回抛出的错误是:" + error);
      return Promise.reject(error);
    }
  );

  //显示错误信息
  function showError(error) {
    var showmessage = "";
    if (error.response && error.response.status == 500)
      showmessage = error.response.data.Message;
    else
      switch (error.message) {
        case "Network Error":
          showmessage = "发生网络错误！";
          break;

        default:
          if (error.message.indexOf("timeout of") != -1)
            showmessage = "请求超时！";
          else showmessage = error.message;
          break;
      }
    if (showmessage == "") {
      showmessage = error.response.data.Message;
    }
    showErrorInfo(showmessage, 10)
    //message.error(showmessage, 10);
    //console.error("显示错误信息：" + showmessage)
  }

  //代理axios方法
  this.instance = instance;
  this.request = instance.request;
  this.put = instance.put;
  this.post = instance.post;
  this.get = instance.get;
  this.delete = instance.delete;
  this.head = instance.head;
  this.patch = instance.patch;
};

//获取基础url，该函数会获取配置文件lt-config.js里LtConfig.baseURL作为根路径，如果有模块路径，也会加上模块路径
ltRest.prototype._getBaseUrl = function () {
  let localLtConfig = {}
  if (typeof LtConfig != "undefined") {
    localLtConfig = reactive(LtConfig)
  } else {
    let temp = localStorage.getItem("LtConfig")
    if (temp) {
      localLtConfig = JSON.parse(temp)
    }
  }
  if (!localLtConfig.baseURL) {
    //后台端口默认80的情况下，前端不用配置IP地址和端口号
    localLtConfig.baseURL =
      window.location.protocol + "//" + window.location.hostname;
  }

  if (!localLtConfig.port || (localLtConfig.port && localLtConfig.port == "")) {
    //前端不配置端口号的情况下，则自动读取用户在浏览器中输入的端口号
    localLtConfig.port = location.port; // window.location.port;
  }

  var baseURL = localLtConfig.baseURL + ":" + localLtConfig.port;

  if (!isURL(baseURL)) {
    console.error("LtConfig.baseURL不是有效的url！");
    return;
  }
  if (baseURL.indexOf("blob") != -1) {
    return baseURL;
  }

  if (baseURL.indexOf("http") == -1) {
    //不以http开头，要补上
    baseURL = "http://" + baseURL;
  }

  if (baseURL[baseURL.length] != "/")
    //不以/结尾要补上
    baseURL += "/";

  if (this._config.service) {
    //有配置模块属性，要加上

    baseURL += this._config.service + "/";
  }

  return baseURL;

  //判断是否正确的url格式
  function isURL(str_url) {
    var strRegex =
      "^((https|http|ftp|rtsp|mms)?://)" +
      "?(([0-9a-z_!~*'().&=+$%-]+: )?[0-9a-z_!~*'().&=+$%-]+@)?" + //ftp的user@
      "(([0-9]{1,3}.){3}[0-9]{1,3}" + // IP形式的URL- 199.194.52.184
      "|" + // 允许IP和DOMAIN（域名）
      "([0-9a-z_!~*'()-]+.)*" + // 域名- www.
      "([0-9a-z][0-9a-z-]{0,61})?[0-9a-z]." + // 二级域名
      "[a-z]{2,6})" + // first level domain- .com or .museum
      "(:[0-9]{1,4})?" + // 端口- :80
      "((/?)|" + // a slash isn't required if there is no file name
      "(/[0-9a-z_!~*'().;?:@&=+$,%#-]+)+/?)$";
    var re = new RegExp(strRegex);
    //re.test()
    if (re.test(str_url)) {
      return true;
    } else {
      return false;
    }
  }
};


function showErrorInfo(message, time) {
  notification.error({
    description: message,
    duration: time,
    message: "错误信息",
    placement: "top"
  })
}

ltRest.all = axios.all;
ltRest.spread = axios.spread;
ltRest.ifLogin = true;

export default ltRest;
